module.exports = __webpack_public_path__ + "img/phone-insanon.780e4833.png";